<ngx-spinner class="custom-spinner" bdColor="rgba(255,255,255,1)" size="medium" color="#fff" type="ball-atom"
  [fullScreen]="true">
  <span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
  </span>
</ngx-spinner>

<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">
    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <!--begin::Toolbar container-->
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <!--begin::Title-->
          <div class="d-flex align-items-center">
            <h1 class="page-heading mt-0 mb-0">
              <svg width="41" height="44" viewBox="0 0 41 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_615_2549)">
                  <path
                    d="M15.1976 30.5794C16.2337 29.2326 17.8276 28.4404 19.5013 28.4404H25.7973C26.7537 28.4404 27.6303 28.0443 28.2679 27.4105L36.0782 19.3298C36.3173 19.0922 36.3173 18.6168 36.0782 18.3792C35.8391 18.1415 35.4406 18.0623 35.2016 18.2207L27.8694 22.5779C27.6303 23.7663 26.5943 24.7169 25.3191 24.7169H17.987C17.5885 24.7169 17.19 24.4 17.19 23.9247C17.19 23.5286 17.5885 23.1325 17.987 23.1325H25.3191C25.877 23.1325 26.3552 22.6572 26.3552 22.1026C26.3552 21.5481 25.877 21.0727 25.3191 21.0727H14.1616C12.5676 21.0727 11.0534 21.7857 10.097 22.9741L7.30762 26.3014L14.4803 31.6885L15.1976 30.5794Z"
                    fill="#265D91" />
                  <path
                    d="M14.8784 33.9066L14.1611 33.352L6.27108 27.4104L4.75684 29.3117L13.3641 35.8079L14.8784 33.9066Z"
                    fill="#265D91" />
                  <path
                    d="M9.93705 17.2701H30.8177C31.4552 17.2701 31.9334 16.7948 31.9334 16.161V10.1401C28.108 11.4869 24.2028 12.1999 20.3773 12.1999C16.5519 12.1999 12.6467 11.4869 8.82129 10.1401V16.161C8.82129 16.7948 9.29947 17.2701 9.93705 17.2701Z"
                    fill="#265D91" />
                  <path
                    d="M31.9334 8.15949V4.59451C31.9334 3.96073 31.4552 3.4854 30.8177 3.4854H25.7967V1.10874C25.7967 0.633412 25.3983 0.158081 24.8404 0.158081H15.9143C15.4361 0.158081 14.958 0.55419 14.958 1.10874V3.4854H9.93705C9.29947 3.4854 8.82129 3.96073 8.82129 4.59451V8.15949C16.4722 11.0115 24.2825 11.0115 31.9334 8.15949ZM16.791 1.98018H23.884V3.40618H16.791V1.98018ZM19.1819 6.97116C19.1819 6.25817 19.7398 5.62439 20.3773 5.62439C21.0149 5.62439 21.5728 6.17894 21.5728 6.97116C21.5728 7.68416 21.0149 8.31793 20.3773 8.31793C19.7398 8.31793 19.1819 7.68416 19.1819 6.97116Z"
                    fill="#265D91" />
                </g>
                <defs>
                  <filter id="filter0_d_615_2549" x="0.756836" y="0.158081" width="39.501" height="43.6498"
                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_615_2549" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_615_2549" result="shape" />
                  </filter>
                </defs>
              </svg>

              Offres du marché
            </h1>
            <!--begin::Menu-->
          </div>
          <!--end::Title-->
          <!--begin::Breadcrumb-->
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              <a routerLink="/accueil" class="text-muted">Accueil</a>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              Offres du marché
            </li>

            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">Liste</li>
            <!--end::Item-->
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
      </div>
      <!--end::Toolbar container-->
    </div>
    <!--end::Toolbar-->
    <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card header-->
          <div class="card-body">
            <div class="title mb-3 d-flex justify-content-between">
              <h4>{{ freeSearch ? 'Recherche libre ' : 'Recherche avancée' }}</h4>
              <a (click)="displayFreeSearch()" class="action-btn show-more-button">
                {{ freeSearch ? 'Recherche avancée' : 'Recherche libre' }}
                <i class="ms-2 fa fa-paper-plane" style="color: #fff;"></i>
              </a>
            </div>

            <div [formGroup]="searchForm" (click)="setActiveForm('guidedSearch')"
              [ngClass]="{'search-free-hide': freeSearch, 'search-free-block': !freeSearch}">
              <div class="tools">
                <div class="form-grid">
                  <!-- <div class="form-item">
                    <input type="text" formControlName="ID_jobOffer" id="Poste"
                      class="form-control form-control-solid mb-3" placeholder="ID" />
                  </div> -->
                  <div class="form-item">
                    <input type="text" formControlName="name" id="Poste" class="form-control form-control-solid mb-3"
                      placeholder="Poste" />
                  </div>
                  <div class="form-item">
                    <input type="text" formControlName="esn_name" id="Poste"
                      class="form-control form-control-solid mb-3" placeholder="Nom Entreprise" />
                  </div>
                  <div class="form-item">
                    <div class="combined-input mb-3">
                      <input type="number" formControlName="years_of_experience" oninput="validity.valid||(value='0');"
                        min="0" class="form-control mb-3" placeholder="Année d’éxperience"
                        aria-label="Amount (to the nearest dollar)" class="nb1" />
                      <input type="number" formControlName="experience_range" oninput="validity.valid||(value='0');"
                        min="0" class="nb2" value="" placeholder="marge_année d’exp" id="marge_année d’exp" />

                      <div class="plusetmois">
                        <i class="fa-solid fa-plus-minus"></i>
                      </div>
                    </div>
                  </div>
                  <div class="form-item">
                    <ng-select [items]="contrat" [bindValue]="'id'"  [bindLabel]="'name'" [multiple]="true" class="mb-3"
                      [notFoundText]="'Aucun élément trouvé'" id="contrat"
                      formControlName="contract_type" placeholder="Type de contrat" autoComplete>
                    </ng-select>
                  </div>
                  <div class="form-item">
                    <div class="combined-input mb-3">
                      <input type="number" formControlName="desired_salary" oninput="validity.valid||(value='0');"
                        min="0" class="nb1" placeholder="Salaire" id="Salaire" />
                      <div class="euro">
                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                            fill="#4B4B4B" />
                        </svg>
                      </div>
                      <input type="number" formControlName="desired_salary_range" (input)="onSalaryRangeInput($event)"
                        (change)="alreadyConverted=false" oninput="validity.valid||(value='0');" min="0" class="nb2"
                        value="" id="marge_tjm" />
                      <div class="icon">
                        <svg width="20" height="15" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.37 10L1.352 5.548V10H0.0780001V0.242H1.352V4.764L5.384 0.242H6.994L2.57 5.128L7.036 10H5.37Z"
                            fill="#4B4B4B" />
                          <path
                            d="M13.889 8.739C14.435 8.739 14.9117 8.62633 15.319 8.401C15.735 8.167 16.06 7.82467 16.294 7.374H18.075C17.737 8.24067 17.1953 8.908 16.45 9.376C15.7047 9.844 14.851 10.078 13.889 10.078C12.875 10.078 11.9737 9.805 11.185 9.259C10.3963 8.70433 9.846 7.96767 9.534 7.049H8.338V6.035H9.3C9.28267 5.79233 9.274 5.60167 9.274 5.463C9.274 5.32433 9.28267 5.13367 9.3 4.891H8.338V3.877H9.534C9.846 2.95833 10.3963 2.226 11.185 1.68C11.9737 1.12533 12.875 0.847999 13.889 0.847999C14.8423 0.847999 15.6917 1.08633 16.437 1.563C17.191 2.031 17.737 2.69833 18.075 3.565H16.294C16.06 3.11433 15.735 2.77633 15.319 2.551C14.9117 2.317 14.435 2.2 13.889 2.2C13.2563 2.2 12.6973 2.34733 12.212 2.642C11.7353 2.93667 11.3713 3.34833 11.12 3.877H13.889V4.891H10.834C10.808 5.073 10.795 5.26367 10.795 5.463C10.795 5.66233 10.808 5.853 10.834 6.035H13.889V7.049H11.12C11.3713 7.58633 11.7353 8.00233 12.212 8.297C12.6973 8.59167 13.2563 8.739 13.889 8.739Z"
                            fill="#4B4B4B" />
                        </svg>
                      </div>
                      <div class="plusetmois">
                        <i class="fa-solid fa-plus-minus"></i>
                      </div>
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="combined-input ">
                      <input type="number" formControlName="tjm" oninput="validity.valid||(value='0');" min="0"
                        class="nb1" placeholder="TJM" id="tjm" />
                      <div class="euro">
                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                            fill="#4B4B4B" />
                        </svg>
                      </div>
                      <input type="number" formControlName="tjm_range" oninput="validity.valid||(value='0');" min="0"
                        class="nb2" value="" id="marge_tjm" />
                      <div class="icon">
                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                            fill="#4B4B4B" />
                        </svg>
                      </div>
                      <div class="plusetmois">
                        <i class="fa-solid fa-plus-minus"></i>
                      </div>
                    </div>
                  </div>
                  <div class="form-item">
                    <ng-select [items]="poste" [bindValue]="'id'" [multiple]="true" 
                      [notFoundText]="'Aucun élément trouvé'" [bindLabel]="'name'" id="Poste"
                      formControlName="post_type" placeholder="Type de poste">
                    </ng-select>
                  </div>
                  <div class="form-item">
                    <ng-select [items]="skillsList"  bindLabel="name_FR" formControlName="skillsAnd"
                      bindValue="name_FR" [multiple]="true" placeholder="Compétences (et)"
                      [notFoundText]="'Aucun élément trouvé'" autoComplete>
                    </ng-select>
                  </div>
              
                <ng-container *ngIf="seeMore">
                  <div class="form-item">
                    <ng-select [items]="skillsList" bindLabel="name_FR" formControlName="skillsOr"
                      bindValue="name_FR" [multiple]="true" [placeholder]="'Compétences (ou)'"
                      [notFoundText]="'Aucun élément trouvé'" autoComplete>
                    </ng-select>
                  </div>
                  <div class="form-item">
                    <ng-select [items]="disponibilite" [multiple]="true" 
                      [notFoundText]="'Aucun élément trouvé'" formControlName="availability" bindLabel="name"
                      bindValue="id" [placeholder]="'Disponibilité'" autoComplete>
                    </ng-select>
                  </div>
                  <div class="form-item">
                    <ng-select (change)="onCountryChange($event)"  [notFoundText]="'Aucun élément trouvé'"
                      [items]="paysList"  bindLabel="name" formControlName="country" [multiple]="true" bindValue="name"
                      [placeholder]="'pays'" autoComplete>
                    </ng-select>
                  </div>
               
                  <div class="form-item">
                    <ng-select [items]="stateList" [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null" bindLabel="name" formControlName="city" [multiple]="true"
                      bindValue="name" (change)="onMobilityChange('add')" [placeholder]="'Ville'"
                      autoComplete [notFoundText]="'Aucun élément trouvé'">
                    </ng-select>
                  </div>
                  <div class="form-item">
                    <div class="position-relative d-flex align-items-center calenderDate">
                      <!--begin::Datepicker-->
                      <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"
                        placeholder="Date de début de publication" inputId="yearpicker" formControlName="start_date"
                        class="form-control"></p-calendar>
                      <!--end::Datepicker-->
                    </div>
                  </div>
                  <div class="form-item">
                    <div class="position-relative d-flex align-items-center calenderDate">
                      <!--begin::Datepicker-->
                      <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"
                        placeholder="Date de fin de publication" inputId="yearpicker" formControlName="end_date"
                        class="form-control"></p-calendar>
                      <!--end::Datepicker-->
                    </div>
                  </div>
                  <div class="form-item">
                    <ng-select [items]="profile" bindLabel="name" [notFoundText]="'Aucun élément trouvé'"
                      formControlName="profile_abroad" bindValue="id" [placeholder]="'Profil à l\'étranger'" autoComplete>
                    </ng-select>
                  </div>
                  <div class="form-item">
                    <ng-select [items]="passeport" bindLabel="name" [notFoundText]="'Aucun élément trouvé'"
                      formControlName="passeport_talent" bindValue="id" [placeholder]="'Passeport talent'" autoComplete>
                    </ng-select>
                  </div>
                  <div class="form-item">
                    <ng-select [items]="state" bindLabel="name" bindValue="id" [multiple]="false" id="state"
                        placeholder="Statut" [notFoundText]="'Aucun élément trouvé'" formControlName="state"
                        [notFoundText]="'Aucun élément trouvé'">
                    </ng-select>
                  </div>
                </ng-container>
              </div>
                <div class="row">
                  <div class="col-lg-3"></div>
                  <div class="col-lg-3"></div>
                  <div class="col-lg-3"></div>
                  <div class="col-lg-3">
                    <div class="see-more mb-5 mt-3">
                      <a class="" (click)="seeMore = !seeMore">Voir {{ !seeMore ? "plus" : "moins" }} de critères de
                        recherche</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div [formGroup]="freeSearchForm" (click)="setActiveForm('freeSearch')">
              <div class="row">
                <div class="col-lg-6" [ngClass]="{'search-free-hide': !freeSearch, 'search-free-block': freeSearch}">
                  <div class="input-group search-libre">
                    <span class="input-group-text">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                          fill="#7E7C7C" />
                      </svg>
                    </span>

                    <input type="text" data-kt-customer-table-filter="search" class="form-control ps-5"
                      placeholder="Rechercher" formControlName="search" (keyup.enter)="onSubmit()" />

                    <div class="tooltip-container tooltip-info">
                      <div class="tooltip-trigger">
                        <i class="fa-solid fa-circle-info" style="font-size: 20px"></i>
                      </div>
                      <div class="tooltip-content">
                        <div class="content">
                          <h4>Opérateur AND :</h4>
                          <p>
                            Utilisez l'opérateur AND pour spécifier que les
                            résultats doivent inclure plusieurs termes.
                          </p>
                          <p>
                            Exemple : software AND engineer renverra des profils
                            qui mentionnent à la fois "software" et "engineer".
                          </p>
                          <h4>Opérateur OR :</h4>
                          <p>
                            Utilisez l'opérateur OR pour spécifier que les
                            résultats peuvent inclure l'un des termes.
                          </p>
                          <p>
                            Exemple : sales OR marketing renverra des profils
                            qui mentionnent soit "sales" soit "marketing".
                          </p>
                          <h4>Opérateur NOT :</h4>
                          <p>
                            Utilisez l'opérateur NOT pour exclure des termes
                            spécifiques des résultats.
                          </p>
                          <p>
                            Exemple : developer NOT manager renverra des profils
                            qui mentionnent "developer" mais pas "manager".
                          </p>
                          <h4>Guillemets pour une expression exacte :</h4>
                          <p>
                            Utilisez des guillemets pour rechercher une
                            expression exacte.
                          </p>
                          <p>
                            Exemple : "product manager" renverra des profils qui
                            mentionnent exactement "product manager".
                          </p>
                          <h4>Parenthèses pour grouper des opérations :</h4>
                          <p>
                            Utilisez des parenthèses pour définir l'ordre
                            d'évaluation des opérations.
                          </p>
                          <p>
                            Exemple : (sales OR marketing) AND manager renverra
                            des profils qui mentionnent "sales" ou "marketing"
                            et "manager".
                          </p>
                          <h4>Recherche standard :</h4>
                          <p>
                            Si aucun opérateur n'est spécifié dans la recherche,
                            le texte sera interprété comme s'il était entre
                            guillemets.
                          </p>
                          <p>
                            Exemple : La recherche product manager sera traitée
                            comme "product manager", suivant la règle 4.
                          </p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              
              </div>
            </div>
            <div class="">
              <div class="search-btn" style="float: right">
                <div class="mb-3  d-flex justify-content-end">
                  <div class="align-items-center recherche">
                    <!-- Bouton Submit -->
                    <button type="submit" class="me-5" (click)="onSubmit()">
                      <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                          fill="white" />
                      </svg>
                      Rechercher
                    </button>
                  </div>
                  <!-- Bouton Reset -->
                  <div class="resett-btn">
                    <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                      title="Réinitialiser">
                      <a (click)="onReset()">
                        <img src="/assets/media/icons/reset.png" alt="" width="30px" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Content container-->
    </div>
    <!--begin::Content-->

    <div *ngIf="!isLoadSpinner" id="kt_app_content" class="app-content flex-column-fluid mb-4">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card content-table">
          <!--begin::Card header-->
          <div class="d-flex flex-wrap my-1 header-grid align-items-center">
            <div class="section_title">
              <h1 class="section-heading my-0">Liste des offres d’emploi</h1>
            </div>
            <!--begin::Tab nav-->
            <ul class="nav nav-pills me-5" *ngIf="listappeloffre && listappeloffre.length">
              <li class="nav-item m-0">
                <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary me-3" data-bs-toggle="tab"
                  href="#kt_project_targets_card_pane">
                  <i class="ki-duotone ki-element-plus fs-1">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </a>
              </li>
              <li class="nav-item m-0">
                <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active" data-bs-toggle="tab"
                  href="#kt_project_targets_table_pane">
                  <i class="ki-duotone ki-row-horizontal fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </a>
              </li>
            </ul>
            <!--end::Tab nav-->
          </div>
          <!--end::Card header-->
          <!--begin::Card body-->
          <div class="card-body pt-0">
            <div class="tab-content for-web">
              <!--begin::Tab pane-->
              <div id="kt_project_targets_card_pane" class="tab-pane fade">
                <!--begin::Row-->
                <div class="row g-6 g-xl-9 justify-content-center">
                  <!--begin::Col-->
                  <div class="col-md-6 col-xxl-4" *ngFor="let offre of listappeloffre">
                    <!--begin::Card-->
                    <div class="card pt-5 p-5">
                      <div class="type-esn">
                        <span *ngIf="offre?.esn?.type == '2'"> Esn</span>
                        <span *ngIf="offre?.esn?.type == '3'">Client Final</span>
                        <span *ngIf="offre?.esn?.type == '4'">Cabinet de Recrutement</span>
                        <span *ngIf="!offre.esn">---</span>
                      </div>
                      <div class="tools">
                        <div class="dropdown">
                          <button
                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                            type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                fill="#265D91" />
                              <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                fill="#265D91" />
                              <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                fill="#265D91" />
                            </svg>
                          </button>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item dropdown" routerLink="/esn-offres-emploi/details-offer1/{{
                                offre.uuid
                              }}">Voir Détail</a>
                            <a aria-disabled="true" class="dropdown-item dropdown"
                              (click)="!unSubscribedEsn() && archiveroffrebesoinesn(offre.uuid)"
                              [class.disabled]="unSubscribedEsn()" [attr.tabindex]="unSubscribedEsn() ? -1 : null"
                              [attr.aria-disabled]="unSubscribedEsn()">
                              Archiver
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="card-body d-flex flex-center flex-column">
                        <div class="symbol symbol-65px symbol-circle mb-5">
                          <img class="circular-image" [src]="
                              !isEsnSubscribed()
                                ? '/assets/media/icons/avatar.jpg'
                                : offre.esn.logo
                                ? url +
                                  '/Company/file/gallery_company/' +
                                  offre.esn.logo
                                : '/assets/media/icons/avatar.jpg'
                            " alt="logo" width="50px" height="50px" />
                        </div>
                        <!-- <a class="job-title title-esn text-center mb-1">
                          {{ offre?.esn?.name ? offre.esn?.name : "---" }}
                        </a> -->
                         <span class="job-title">
                              <a
                              class="first-td"
                              routerLink="/entreprises/details-entreprise/{{offre?.esn?.uuid}}"
                              >{{offre.esn.name &&  offre.esn.name!=="null"  ? offre.esn.name : '---' }}</a>
                          </span>
                        <div class="poste">
                          <span routerLink="/esn-offres-emploi/details-offer1/{{offre.uuid}}" class="name-offre mb-5"
                            style="cursor:pointer">{{ offre.name && offre?.name!=="null" && offre?.name!='0' ?
                            offre.name : "---" }}
                          </span>
                        </div>
                        <div class="text-center flex-wrap mt-5 mb-5">
                          <ng-container>
                            <div class="skills" *ngIf="getSkillsArray(offre).length > 0; else emptySkills"
                              [ngbTooltip]="getSkillsArray(offre).length > 3 ? getSkillsList(offre.skills) : null"
                              placement="top">
                              <span class="skill"
                                *ngFor="let skill of getSkillsArray(offre).slice(0, 3); let i = index">
                                <span class="badge" [ngClass]="i % 2 === 0 ? 'skill-content' : 'skill-desc'">
                                  {{ skill }}
                                </span>
                              </span>
                              <span *ngIf="getSkillsArray(offre).length > 3" class="more-icon">
                                <i class="fa fa-ellipsis-h"></i>
                              </span>
                            </div>
                            <ng-template #emptySkills> <span>---</span></ng-template>
                          </ng-container>
                        </div>
                        <div class="info">
                          <div class="type mb-3" *ngIf="offre.salary && offre.salary !== '0'">
                            <span>Salaire :</span>
                            {{ offre.salary && offre.salary !== "null" && offre.salary !='0' ? offre.salary + " €" :
                            '---'}}
                          </div>
                          <div class="type mb-3" *ngIf="offre.tjm && offre.tjm !== '0'">
                            <span>Tjm :</span>
                            {{ offre.tjm && offre.tjm !== "null" && offre.tjm !='0' ? offre.tjm + " €" : '---'}}
                          </div>
                        </div>
                        <div class="experience">
                          <div class="exper mb-3">
                            <span>Expérience :</span>
                             <span *ngIf="offre.years_of_experience !='0' && offre.years_of_experience!==null && offre.years_of_experience !='1'">
                              {{offre.years_of_experience+' ans' }}</span>
                              <span *ngIf="offre.years_of_experience == '0' || offre.years_of_experience === null">Aucune expérience</span>
                              <span *ngIf="offre.years_of_experience === '1'">1 an</span>
                          </div>
                        </div>
                      </div>
                      <div class="sep"></div>
                      <div class="foot p-5">
                        <div class="plus">
                          <a routerLink="/esn-offres-emploi/details-offer1/{{
                              offre.uuid
                            }}">Voir plus</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <app-empty-state *ngIf="listappeloffre && !listappeloffre.length"
                    [title]="parentItem"></app-empty-state>
                  <div class="pagination" *ngIf="listappeloffre && listappeloffre.length > 0">
                    <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                      [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                      aria-label="Select page">
                    </mat-paginator>
                  </div>
                </div>
              </div>
              <!--end::Tab pane-->
              <!--begin::Tab pane-->
              <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                <div class="content">
                  <div class="pt-3">
                    <!--begin::Table-->
                    <div class="table-responsive" id="kt_customers_table"
                      *ngIf="listappeloffre && listappeloffre.length">
                      <table class="table align-middle gy-4 style-table">
                        <thead>
                          <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                            <ng-container *ngFor="let item of listNames; let i = index">
                              <th class="min-w-175px" [ngClass]="getClass(item)">
                                <span>{{ item }}</span>
                              </th>
                            </ng-container>
                            <th class="min-w-150px stiky-column-action"><span>Actions</span></th>
                            <th class="min-w-30px stiky-column">
                              <div class="dropdown">
                                <button class="dropdown-toggle" type="button" id="dropdownMenuButton"
                                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
                                    fill="none">
                                    <g filter="url(#filter0_d_588_1699)">
                                      <rect x="4" width="20" height="20" rx="4" fill="#63C3E8" fill-opacity="0.12"
                                        shape-rendering="crispEdges" />
                                    </g>
                                    <path
                                      d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                      fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                                    <defs>
                                      <filter id="filter0_d_588_1699" x="0" y="0" width="28" height="28"
                                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                          values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                          result="effect1_dropShadow_588_1699" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_588_1699"
                                          result="shape" />
                                      </filter>
                                    </defs>
                                  </svg>
                                </button>
                                <div class="dropdown-table">
                                  <div class="dropdown-menu list-actions-content" aria-labelledby="dropdownMenuButton">
                                    <div class="d-flex checkbox mb-2 menu" *ngFor="
                                        let item of dataHeader;
                                        let i = index
                                      ">
                                      <div class="form-check form-check-sm form-check-custom form-check-solid"
                                        *ngIf="item.name != 'checkbox'">
                                        <input class="form-check-input checkbox-border" [checked]="
                                            (item.checked == 'oui' &&
                                              !item.checked_user) ||
                                            (item.checked_user == 'oui' &&
                                              (item.checked == 'non' ||
                                                item.checked == 'oui'))
                                          " (change)="
                                            changeSelection($event, item, i)
                                          " type="checkbox" value="1" [disabled]="
                                            item.name === 'Logo entreprise' ||
                                            item.name === 'Nom entreprise'
                                          " />
                                        <a class="dropdown-item">{{
                                          item.name
                                          }}</a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody class="fw-semibold text-gray-600">
                          <tr *ngFor="let offre of listappeloffre">
                            <!-- <td *ngIf="listNames.includes('ID')">
                              <a class="first-td" routerLink="/esn-offres-emploi/details-offer1/{{
                                  offre.uuid
                                }}" class="poste"><span class="first-td">{{
                                  offre.ID_jobOffer ? offre.ID_jobOffer : "---"
                                  }}</span></a>
                            </td> -->
                            <td *ngIf="listNames.includes('Logo entreprise')">
                              <img class="circular-image" [src]="
                                  !isEsnSubscribed()
                                    ? '/assets/media/icons/avatar.jpg'
                                    : offre.esn.logo
                                    ? url +
                                      '/Company/file/gallery_company/' +
                                      offre.esn.logo
                                    : '/assets/media/icons/avatar.jpg'
                                " alt="logo" width="50px" height="50px" />
                            </td>
                            <td *ngIf="listNames.includes('Nom entreprise')" class="td-fixed weight">
                              <a
                                class="first-td"
                                routerLink="/entreprises/details-entreprise/{{
                                  offre?.esn?.uuid
                                }}"
                                >{{ offre?.esn?.name ? offre?.esn?.name : "---" }}</a>
                            </td>

                            <td *ngIf="listNames.includes('Type')">
                              <span class="wrapping" [ngClass]="
                                  offre?.esn?.type == '1'
                                    ? 'type-data'
                                    : offre?.esn?.type == '2'
                                    ? 'esn-type'
                                    : offre?.esn?.type == '3'
                                    ? 'client-type'
                                    : 'centre-type'
                                ">
                                {{
                                offre?.esn?.type == "1"
                                ? "Entrepeise"
                                : offre?.esn?.type == "2"
                                ? "ESN"
                                : offre?.esn?.type == "3"
                                ? "Client Final"
                                : "Cabinet de Recrutement"
                                }}</span>
                            </td>
                            <td *ngIf="listNames.includes('Poste')" class="td-fixed2">
                              <a routerLink="/esn-offres-emploi/details-offer1/{{
                                  offre.uuid
                                }}" class="poste"><span class="first-td poste-wrapper">{{
                                  offre.name ? offre.name : "---"
                                  }}</span></a>
                            </td>
                            <td *ngIf="listNames.includes('Date de publication')">
                              <span>
                                {{
                                !offre.start_date
                                ? "---"
                                : offre.start_date
                                .split(
                                "
                                "
                                )[0]
                                .split("-")
                                .reverse()
                                .join("/")
                                }}
                              </span>
                            </td>
                            <td *ngIf="listNames.includes('Années d’expérience')">
                                <span *ngIf="offre.years_of_experience !='0' && offre.years_of_experience!==null && offre.years_of_experience !='1'">
                                {{offre.years_of_experience+' ans' }}</span>
                                <span *ngIf="offre.years_of_experience == '0' || offre.years_of_experience === null">Aucune expérience</span>
                                <span *ngIf="offre.years_of_experience === '1'">1 an</span>
                            </td>
                            <td *ngIf="listNames.includes('Type de contrat')">
                              <ng-container>
                                <div class="td-contracts-type"
                                  *ngIf="offre?.contract_type?.length > 0; else emptyContract" placement="top"
                                  [ngbTooltip]="offre?.contract_type?.length > 3 ? getContractTypeList(offre?.contract_type) : null">
                                  <div class="td-contracts-item"
                                    *ngFor="let contract of offre.contract_type | slice:0:3">
                                    <span [ngSwitch]="contract">
                                      <span *ngSwitchCase="1">Alternance</span>
                                      <span *ngSwitchCase="2">Autres type de contrat</span>
                                      <span *ngSwitchCase="3">CDD</span>
                                      <span *ngSwitchCase="4">CDI</span>
                                      <span *ngSwitchCase="5">Freelance</span>
                                      <span *ngSwitchCase="6">Portage salarial</span>
                                      <span *ngSwitchCase="7">Stage</span>
                                    </span>
                                  </div>
                                  <span *ngIf="offre?.contract_type?.length > 3" class="more-icon">
                                    <i class="fa fa-ellipsis-h"></i>
                                  </span>
                                </div>
                                <ng-template #emptyContract><span>---</span></ng-template>
                              </ng-container>
                            </td>
                            <td *ngIf="listNames.includes('Salaire')">
                              <span *ngIf="
                                  offre.salary !== '0' || offre.salary !== null
                                ">{{
                                offre.salary ? offre.salary + "&euro;" : "---"
                                }}
                              </span>
                              <span *ngIf="
                                  offre.salary === '0' || offre.salary === null
                                ">---</span>
                            </td>
                            <td *ngIf="listNames.includes('TJM')">
                              <span *ngIf="offre.tjm !== '0' || offre.tjm !== null">{{
                                offre.tjm ? offre.tjm + "&euro;" : "---"
                                }}</span>
                              <span *ngIf="offre.tjm === '0' || offre.tjm === null">---</span>
                            </td>

                            <td *ngIf="listNames.includes('Type de poste')">
                              <span *ngIf="offre.post_type == 1" class="badge remote">A distance</span>
                              <span *ngIf="offre.post_type == 2" class="badge onsite">Hybride</span>
                              <span *ngIf="offre.post_type == 3" class="badge hybrid">Sur site</span>
                              <span *ngIf="!offre.post_type">---</span>

                              <!-- <span class="badge remote">Télétravail</span> -->
                            </td>
                            <td *ngIf="listNames.includes('Compétences')">
                              <ng-container>
                                <div class="skills" *ngIf="getSkillsArray(offre).length > 0; else emptySkills"
                                  [ngbTooltip]="getSkillsArray(offre).length > 3 ? getSkillsList(offre.skills) : null"
                                  placement="top">
                                  <span class="skill"
                                    *ngFor="let skill of getSkillsArray(offre).slice(0, 3); let i = index">
                                    <span class="badge" [ngClass]="i % 2 === 0 ? 'skill-content' : 'skill-desc'">
                                      {{ skill }}
                                    </span>
                                  </span>
                                  <span *ngIf="getSkillsArray(offre).length > 3" class="more-icon">
                                    <i class="fa fa-ellipsis-h"></i>
                                  </span>
                                </div>
                                <ng-template #emptySkills> <span>---</span></ng-template>
                              </ng-container>
                            </td>

                            <td *ngIf="listNames.includes('Pays')">
                              <ng-container
                                *ngIf="offre.country.length > 0 && offre.country !== 'null' && offre.country !== '0'; else emptyCity">
                                <span class="poste-wrap"
                                  [ngbTooltip]="offre.country.length > 3 ? getRemainingPays(offre.country) : null"
                                  tooltipPosition="top">
                                  <div *ngFor="let countr of offre.country.slice(0, 3); let i = index">
                                    {{ countr }}
                                  </div>
                                  <div *ngIf="offre.country.length > 3" class="more-icon">
                                    <i class="fa fa-ellipsis-h"></i>
                                  </div>
                                </span>
                              </ng-container>
                              <ng-template #emptyCity><span>---</span></ng-template>
                            </td>
                            <td *ngIf="listNames.includes('Ville')">
                              <ng-container
                                *ngIf="offre.city.length > 0 && offre.city !== 'null' && offre.city !== '0'; else emptyCity">
                                <span class="poste-wrap"
                                  [ngbTooltip]="offre.city.length > 3 ? getRemainingPays(offre.city) : null"
                                  tooltipPosition="top">
                                  <div *ngFor="let mobility of offre.city.slice(0, 3); let i = index">
                                    {{ mobility }}
                                  </div>
                                  <div *ngIf="offre.city.length > 3" class="more-icon">
                                    <i class="fa fa-ellipsis-h"></i>
                                  </div>
                                </span>
                              </ng-container>
                              <ng-template #emptyCity><span>---</span></ng-template>
                            </td>
                            <td *ngIf="listNames.includes('Passeport talent')">
                              <span class="badge actif" *ngIf="offre.passeport_talent == 1">
                                <i class="fa-solid fa-circle"></i> Oui</span>
                              <span class="badge desactif" *ngIf="offre.passeport_talent == 0">
                                <i class="fa-solid fa-circle"></i> Non</span>
                            </td>
                            <td *ngIf="listNames.includes('Profil à l’étranger')">
                              <span class="badge actif" *ngIf="offre.profile_abroad == 1">
                                <i class="fa-solid fa-circle"></i> Oui</span>
                              <span class="badge desactif" *ngIf="offre.profile_abroad == 0">
                                <i class="fa-solid fa-circle"></i> Non</span>
                            </td>
                            <td *ngIf="listNames.includes('Statut')">
                              <span class="badge actif" *ngIf="offre.state == 0">
                                <i class="fa-solid fa-circle"></i> Actif</span>
                              <span class="badge desactif" *ngIf="offre.state == 1">
                                <i class="fa-solid fa-circle"></i> Non
                                actif</span>
                            </td>
                            <td class="td-fixed-3">
                              <button mat-button [matMenuTriggerFor]="menu"
                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                                <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                    fill="#265D91" />
                                  <circle cx="2.44739" cy="2.44739" r="2.44739"
                                    transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                  <circle cx="2.44739" cy="2.44739" r="2.44739"
                                    transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                </svg>
                              </button>
                              <mat-menu #menu="matMenu">
                                <a mat-menu-item routerLink="/esn-offres-emploi/details-offer1/{{offre.uuid}}">
                                  Voir Détail
                                </a>
                                <button mat-menu-item [ngClass]="{'disabled-button': unSubscribedEsn()}"
                                  (click)="!unSubscribedEsn() && archiveroffrebesoinesn(offre.uuid)"
                                  [class.disabled]="unSubscribedEsn()" [attr.tabindex]="unSubscribedEsn() ? -1 : null"
                                  [attr.aria-disabled]="unSubscribedEsn()">
                                  Archiver
                                </button>
                              </mat-menu>
                            </td>
                            <td class="td-fixed-4"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <app-empty-state *ngIf="listappeloffre && !listappeloffre.length"
                      [title]="parentItem"></app-empty-state>
                    <div class="pagination" *ngIf="listappeloffre && listappeloffre.length > 0">
                      <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                        [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                        aria-label="Select page">
                      </mat-paginator>
                    </div>
                  </div>
                </div>
              </div>
              <!--end::Tab pane-->
            </div>
            <div class="tab-content for-mobile">
              <!--begin::Tab pane-->
              <div id="kt_project_targets_card_pane" class="tab-pane fade show active">
                <!--begin::Row-->
                <div class="row g-6 g-xl-9 justify-content-center">
                  <!--begin::Col-->
                  <div class="col-md-6 col-xxl-4" *ngFor="let offre of listappeloffre">
                    <!--begin::Card-->
                    <div class="card pt-5 p-5">
                      <div class="type-esn">
                        <span *ngIf="offre?.esn?.type == '2'"> Esn</span>
                        <span *ngIf="offre?.esn?.type == '3'">Client Final</span>
                        <span *ngIf="offre?.esn?.type == '4'">Cabinet de Recrutement</span>
                        <span *ngIf="!offre.esn">---</span>
                      </div>
                      <div class="tools">
                        <div class="dropdown">
                          <button
                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                            type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                fill="#265D91" />
                              <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                fill="#265D91" />
                              <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                fill="#265D91" />
                            </svg>
                          </button>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item dropdown" routerLink="/esn-offres-emploi/details-offer1/{{
                                offre.uuid
                              }}">Voir Détail</a>
                            <a aria-disabled="true" class="dropdown-item dropdown"
                              (click)="!unSubscribedEsn() && archiveroffrebesoinesn(offre.uuid)"
                              [class.disabled]="unSubscribedEsn()" [attr.tabindex]="unSubscribedEsn() ? -1 : null"
                              [attr.aria-disabled]="unSubscribedEsn()">
                              Archiver
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="card-body d-flex flex-center flex-column">
                        <div class="symbol symbol-65px symbol-circle mb-5">
                          <img class="circular-image" [src]="
                              !isEsnSubscribed()
                                ? '/assets/media/icons/avatar.jpg'
                                : offre.esn.logo
                                ? url +
                                  '/Company/file/gallery_company/' +
                                  offre.esn.logo
                                : '/assets/media/icons/avatar.jpg'
                            " alt="logo" width="50px" height="50px" />
                        </div>
                        <span class="job-title">
                              <a
                              class="first-td"
                              routerLink="/entreprises/details-entreprise/{{offre?.esn?.uuid}}"
                              >{{offre.esn.name &&  offre.esn.name!=="null"  ? offre.esn.name : '---' }}</a>
                          </span>
                        <div class="poste">
                          <a routerLink="/esn-offres-emploi/details-offer1/{{offre.uuid}}" class="name-offre mb-5"
                            style="cursor:pointer">{{ offre.name && offre?.name!=="null" && offre?.name!='0' ?
                            offre.name : "---" }}
                          </a>
                        </div>
                        <div class="text-center flex-wrap mt-5 mb-5">
                          <ng-container>
                            <div class="skills" *ngIf="getSkillsArray(offre).length > 0; else emptySkills"
                              [ngbTooltip]="getSkillsArray(offre).length > 3 ? getSkillsList(offre.skills) : null"
                              placement="top">
                              <span class="skill"
                                *ngFor="let skill of getSkillsArray(offre).slice(0, 3); let i = index">
                                <span class="badge" [ngClass]="i % 2 === 0 ? 'skill-content' : 'skill-desc'">
                                  {{ skill }}
                                </span>
                              </span>
                              <span *ngIf="getSkillsArray(offre).length > 3" class="more-icon">
                                <i class="fa fa-ellipsis-h"></i>
                              </span>
                            </div>
                            <ng-template #emptySkills> <span>---</span></ng-template>
                          </ng-container>
                        </div>
                        <div class="info">
                          <div class="type mb-3">
                            <span>Salaire :</span>
                            {{ offre.salary && offre.salary !== "null" && offre.salary !='0' ? offre.salary + " €" :
                            '---'}}
                          </div>
                          <div class="type mb-3">
                            <span>Tjm :</span>
                            {{ offre.tjm && offre.tjm !== "null" && offre.tjm !='0' ? offre.tjm + " €" : '---'}}
                          </div>
                        </div>
                        <div class="experience">
                          <div class="exper mb-3">
                            <span>Expérience :</span>
                            <span *ngIf="offre.years_of_experience !='0' && offre.years_of_experience!==null && offre.years_of_experience !='1'">
                                {{offre.years_of_experience+' ans' }}</span>
                                <span *ngIf="offre.years_of_experience == '0' || offre.years_of_experience === null">Aucune expérience</span>
                                <span *ngIf="offre.years_of_experience === '1'">1 an</span>
                          </div>
                        </div>
                      </div>
                      <div class="sep"></div>
                      <div class="foot p-5">
                        <div class="plus">
                          <a routerLink="/esn-offres-emploi/details-offer1/{{
                              offre.uuid
                            }}">Voir plus</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <app-empty-state *ngIf="listappeloffre && !listappeloffre.length"
                    [title]="parentItem"></app-empty-state>
                  <div class="pagination" *ngIf="listappeloffre && listappeloffre.length > 0">
                    <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                      [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                      aria-label="Select page">
                    </mat-paginator>
                  </div>
                </div>
              </div>
              <!--end::Table-->
            </div>
            <!--end::Card body-->
          </div>
        </div>
        <!--end::Content container-->
      </div>
      <!--end::Content-->
    </div>
    <!--end::Content wrapper-->
    <!--begin::Footer-->

    <!--end::Footer-->
    <!--end:::Main-->
  </div>

  <div class="modal fade" id="propose" tabindex="-1" aria-hidden="true">
    <!--begin::Modal dialog-->
    <div class="modal-dialog mw-700px modal-dialog-centered">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header pb-0 border-0 d-flex justify-content-end">
          <!--begin::Close-->
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
            <i class="ki-duotone ki-cross fs-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body scroll-y mx-5 mx-xl-10 pt-0 pb-15">
          <!--begin::Heading-->
          <div class="text-center mb-13">
            <!--begin::Title-->
            <h1 class="d-flex justify-content-center align-items-center mb-3">
              Proposer un candidat
              <span class="badge badge-circle badge-secondary ms-3">81</span>
            </h1>
            <!--end::Title-->
          </div>
          <!--end::Heading-->
          <!--begin::Users-->
          <div class="mh-475px scroll-y me-n7 pe-7">
            <!--begin::User-->
            <div class="border border-hover-primary p-7 rounded mb-7">
              <!--begin::Info-->
              <div class="d-flex flex-stack pb-3">
                <!--begin::Info-->
                <div class="d-flex">
                  <!--begin::Avatar-->
                  <div class="symbol symbol-circle symbol-45px">
                    <img src="assets/media/avatars/300-20.jpg" alt="" />
                  </div>
                  <!--end::Avatar-->
                  <!--begin::Details-->
                  <div class="ms-5">
                    <!--begin::Name-->
                    <div class="d-flex align-items-center">
                      <a href="../../demo1/dist/pages/user-profile/overview.html"
                        class="text-dark fw-bold text-hover-primary fs-5 me-4">Amine chouri</a>
                      <!--begin::Label-->
                      <span class="badge badge-light-success d-flex align-items-center fs-8 fw-semibold">
                        <i class="ki-duotone ki-star fs-8 text-success me-1"></i>Author</span>
                      <!--end::Label-->
                    </div>
                    <!--end::Name-->
                    <!--begin::Desc-->
                    <span class="text-muted fw-semibold mb-3">Art Director</span>
                    <!--end::Desc-->
                  </div>
                  <!--end::Details-->
                </div>
                <!--end::Info-->
                <!--begin::Stats-->
                <div clas="d-flex">
                  <!--begin::Price-->
                  <div class="text-end pb-3">
                    <span class="text-dark fw-bold fs-5">$75.60</span>
                    <span class="text-muted fs-7">/hr</span>
                  </div>
                  <!--end::Price-->
                </div>
                <!--end::Stats-->
              </div>
              <!--end::Info-->
              <!--begin::Wrapper-->
              <div class="p-0">
                <!--begin::Section-->
                <div class="d-flex flex-column">
                  <!--begin::Text-->
                  <p class="text-gray-700 fw-semibold fs-6 mb-4">
                    First, a disclaimer - the entire process writing a blog post
                    often takes more.
                  </p>
                  <!--end::Text-->
                  <!--begin::Tags-->
                  <div class="d-flex text-gray-700 fw-semibold fs-7">
                    <!--begin::Tag-->
                    <span class="border border-2 rounded me-3 p-1 px-2">Art Director</span>
                    <!--end::Tag-->
                    <!--begin::Tag-->
                    <span class="border border-2 rounded me-3 p-1 px-2">UX</span>
                    <!--end::Tag-->
                    <!--begin::Tag-->
                    <span class="border border-2 rounded me-3 p-1 px-2">Laravel</span>
                    <!--end::Tag-->
                  </div>
                  <!--end::Tags-->
                </div>
                <!--end::Section-->
                <!--begin::Footer-->
                <div class="d-flex flex-column">
                  <!--begin::Separator-->
                  <div class="separator separator-dashed border-muted my-5"></div>
                  <!--end::Separator-->
                  <!--begin::Action-->
                  <div class="d-flex flex-stack">
                    <!--begin::Progress-->
                    <div class="d-flex flex-column mw-200px">
                      <div class="d-flex align-items-center mb-2">
                        <span class="text-gray-700 fs-6 fw-semibold me-2">90%</span>
                        <span class="text-muted fs-8">Job Success</span>
                      </div>
                      <div class="progress h-6px w-200px">
                        <div class="progress-bar bg-primary" role="progressbar" style="width: 90%" aria-valuenow="90"
                          aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                    <!--end::Progress-->
                    <!--begin::Button-->
                    <a href="#" class="btn btn-sm btn-primary">Select</a>
                    <!--end::Button-->
                  </div>
                  <!--end::Action-->
                </div>
                <!--end::Footer-->
              </div>
              <!--end::Wrapper-->
            </div>
            <!--end::User-->
            <!--begin::User-->
            <div class="border border-hover-primary p-7 rounded mb-7">
              <!--begin::Info-->
              <div class="d-flex flex-stack pb-3">
                <!--begin::Info-->
                <div class="d-flex">
                  <!--begin::Avatar-->
                  <div class="symbol symbol-circle symbol-45px">
                    <img src="assets/media/avatars/300-11.jpg" alt="" />
                  </div>
                  <!--end::Avatar-->
                  <!--begin::Details-->
                  <div class="ms-5">
                    <!--begin::Name-->
                    <div class="d-flex align-items-center">
                      <a href="../../demo1/dist/pages/user-profile/overview.html"
                        class="text-dark fw-bold text-hover-primary fs-5 me-4">Sean Bean</a>
                      <!--begin::Label-->
                      <span class="badge badge-light-success d-flex align-items-center fs-8 fw-semibold">
                        <i class="ki-duotone ki-star fs-8 text-success me-1"></i>Author</span>
                      <!--end::Label-->
                    </div>
                    <!--end::Name-->
                    <!--begin::Desc-->
                    <span class="text-muted fw-semibold mb-3">Project Manager</span>
                    <!--end::Desc-->
                  </div>
                  <!--end::Details-->
                </div>
                <!--end::Info-->
                <!--begin::Stats-->
                <div clas="d-flex">
                  <!--begin::Price-->
                  <div class="text-end pb-3">
                    <span class="text-dark fw-bold fs-5">$65.45</span>
                    <span class="text-muted fs-7">/hr</span>
                  </div>
                  <!--end::Price-->
                </div>
                <!--end::Stats-->
              </div>
              <!--end::Info-->
              <!--begin::Wrapper-->
              <div class="p-0">
                <!--begin::Section-->
                <div class="d-flex flex-column">
                  <!--begin::Text-->
                  <p class="text-gray-700 fw-semibold fs-6 mb-4">
                    Outlines keep you honest. They stop you from indulging.
                  </p>
                  <!--end::Text-->
                  <!--begin::Tags-->
                  <div class="d-flex text-gray-700 fw-semibold fs-7">
                    <!--begin::Tag-->
                    <span class="border border-2 rounded me-3 p-1 px-2">HTML</span>
                    <!--end::Tag-->
                    <!--begin::Tag-->
                    <span class="border border-2 rounded me-3 p-1 px-2">Javascript</span>
                    <!--end::Tag-->
                    <!--begin::Tag-->
                    <span class="border border-2 rounded me-3 p-1 px-2">Python</span>
                    <!--end::Tag-->
                  </div>
                  <!--end::Tags-->
                </div>
                <!--end::Section-->
                <!--begin::Footer-->
                <div class="d-flex flex-column">
                  <!--begin::Separator-->
                  <div class="separator separator-dashed border-muted my-5"></div>
                  <!--end::Separator-->
                  <!--begin::Action-->
                  <div class="d-flex flex-stack">
                    <!--begin::Progress-->
                    <div class="d-flex flex-column mw-200px">
                      <div class="d-flex align-items-center mb-2">
                        <span class="text-gray-700 fs-6 fw-semibold me-2">58%</span>
                        <span class="text-muted fs-8">Job Success</span>
                      </div>
                      <div class="progress h-6px w-200px">
                        <div class="progress-bar bg-success" role="progressbar" style="width: 58%" aria-valuenow="58"
                          aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                    <!--end::Progress-->
                    <!--begin::Button-->
                    <a href="#" class="btn btn-sm btn-primary">Select</a>
                    <!--end::Button-->
                  </div>
                  <!--end::Action-->
                </div>
                <!--end::Footer-->
              </div>
              <!--end::Wrapper-->
            </div>
            <!--end::User-->
            <!--begin::User-->
            <div class="border border-hover-primary p-7 rounded mb-7">
              <!--begin::Info-->
              <div class="d-flex flex-stack pb-3">
                <!--begin::Info-->
                <div class="d-flex">
                  <!--begin::Avatar-->
                  <div class="symbol symbol-circle symbol-45px">
                    <img src="assets/media/avatars/300-2.jpg" alt="" />
                  </div>
                  <!--end::Avatar-->
                  <!--begin::Details-->
                  <div class="ms-5">
                    <!--begin::Name-->
                    <div class="d-flex align-items-center">
                      <a href="../../demo1/dist/pages/user-profile/overview.html"
                        class="text-dark fw-bold text-hover-primary fs-5 me-4">Lusy Kunic</a>
                      <!--begin::Label-->
                      <span class="m-0"></span>
                      <!--end::Label-->
                    </div>
                    <!--end::Name-->
                    <!--begin::Desc-->
                    <span class="text-muted fw-semibold mb-3">DevOPs</span>
                    <!--end::Desc-->
                  </div>
                  <!--end::Details-->
                </div>
                <!--end::Info-->
                <!--begin::Stats-->
                <div clas="d-flex">
                  <!--begin::Price-->
                  <div class="text-end pb-3">
                    <span class="text-dark fw-bold fs-5">$60,45</span>
                    <span class="text-muted fs-7">/hr</span>
                  </div>
                  <!--end::Price-->
                </div>
                <!--end::Stats-->
              </div>
              <!--end::Info-->
              <!--begin::Wrapper-->
              <div class="p-0">
                <!--begin::Section-->
                <div class="d-flex flex-column">
                  <!--begin::Text-->
                  <p class="text-gray-700 fw-semibold fs-6 mb-4">
                    Long before you sit down to put digital pen to paper you need
                    make sure you have to sit down and write.
                  </p>
                  <!--end::Text-->
                  <!--begin::Tags-->
                  <div class="d-flex text-gray-700 fw-semibold fs-7">
                    <!--begin::Tag-->
                    <span class="border border-2 rounded me-3 p-1 px-2">Figma</span>
                    <!--end::Tag-->
                    <!--begin::Tag-->
                    <span class="border border-2 rounded me-3 p-1 px-2">SASS</span>
                    <!--end::Tag-->
                    <!--begin::Tag-->
                    <span class="border border-2 rounded me-3 p-1 px-2">CSS</span>
                    <!--end::Tag-->
                  </div>
                  <!--end::Tags-->
                </div>
                <!--end::Section-->
                <!--begin::Footer-->
                <div class="d-flex flex-column">
                  <!--begin::Separator-->
                  <div class="separator separator-dashed border-muted my-5"></div>
                  <!--end::Separator-->
                  <!--begin::Action-->
                  <div class="d-flex flex-stack">
                    <!--begin::Progress-->
                    <div class="d-flex flex-column mw-200px">
                      <div class="d-flex align-items-center mb-2">
                        <span class="text-gray-700 fs-6 fw-semibold me-2">86%</span>
                        <span class="text-muted fs-8">Job Success</span>
                      </div>
                      <div class="progress h-6px w-200px">
                        <div class="progress-bar bg-warning" role="progressbar" style="width: 86%" aria-valuenow="86"
                          aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                    <!--end::Progress-->
                    <!--begin::Button-->
                    <a href="#" class="btn btn-sm btn-primary">Select</a>
                    <!--end::Button-->
                  </div>
                  <!--end::Action-->
                </div>
                <!--end::Footer-->
              </div>
              <!--end::Wrapper-->
            </div>
            <!--end::User-->
            <!--begin::User-->
            <div class="border border-hover-primary p-7 rounded">
              <!--begin::Info-->
              <div class="d-flex flex-stack pb-3">
                <!--begin::Info-->
                <div class="d-flex">
                  <!--begin::Avatar-->
                  <div class="symbol symbol-circle symbol-45px">
                    <img src="assets/media/avatars/300-5.jpg" alt="" />
                  </div>
                  <!--end::Avatar-->
                  <!--begin::Details-->
                  <div class="ms-5">
                    <!--begin::Name-->
                    <div class="d-flex align-items-center">
                      <a href="../../demo1/dist/pages/user-profile/overview.html"
                        class="text-dark fw-bold text-hover-primary fs-5 me-4">Mat Dillon</a>
                      <!--begin::Label-->
                      <span class="m-0"></span>
                      <!--end::Label-->
                    </div>
                    <!--end::Name-->
                    <!--begin::Desc-->
                    <span class="text-muted fw-semibold mb-3">QA Managers</span>
                    <!--end::Desc-->
                  </div>
                  <!--end::Details-->
                </div>
                <!--end::Info-->
                <!--begin::Stats-->
                <div clas="d-flex">
                  <!--begin::Price-->
                  <div class="text-end pb-3">
                    <span class="text-dark fw-bold fs-5">$70,30</span>
                    <span class="text-muted fs-7">/hr</span>
                  </div>
                  <!--end::Price-->
                </div>
                <!--end::Stats-->
              </div>
              <!--end::Info-->
              <!--begin::Wrapper-->
              <div class="p-0">
                <!--begin::Section-->
                <div class="d-flex flex-column">
                  <!--begin::Text-->
                  <p class="text-gray-700 fw-semibold fs-6 mb-4">
                    First, a disclaimer - the entire process writing a blog post
                    often takes more than couple of hours.
                  </p>
                  <!--end::Text-->
                  <!--begin::Tags-->
                  <div class="d-flex text-gray-700 fw-semibold fs-7">
                    <!--begin::Tag-->
                    <span class="border border-2 rounded me-3 p-1 px-2">Figma</span>
                    <!--end::Tag-->
                    <!--begin::Tag-->
                    <span class="border border-2 rounded me-3 p-1 px-2">SASS</span>
                    <!--end::Tag-->
                    <!--begin::Tag-->
                    <span class="border border-2 rounded me-3 p-1 px-2">CSS</span>
                    <!--end::Tag-->
                  </div>
                  <!--end::Tags-->
                </div>
                <!--end::Section-->
                <!--begin::Footer-->
                <div class="d-flex flex-column">
                  <!--begin::Separator-->
                  <div class="separator separator-dashed border-muted my-5"></div>
                  <!--end::Separator-->
                  <!--begin::Action-->
                  <div class="d-flex flex-stack">
                    <!--begin::Progress-->
                    <div class="d-flex flex-column mw-200px">
                      <div class="d-flex align-items-center mb-2">
                        <span class="text-gray-700 fs-6 fw-semibold me-2">70%</span>
                        <span class="text-muted fs-8">Job Success</span>
                      </div>
                      <div class="progress h-6px w-200px">
                        <div class="progress-bar bg-danger" role="progressbar" style="width: 70%" aria-valuenow="70"
                          aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                    <!--end::Progress-->
                    <!--begin::Button-->
                    <a href="#" class="btn btn-sm btn-primary">Select</a>
                    <!--end::Button-->
                  </div>
                  <!--end::Action-->
                </div>
                <!--end::Footer-->
              </div>
              <!--end::Wrapper-->
            </div>
            <!--end::User-->
          </div>
          <!--end::Users-->
        </div>
        <!--end::Modal Body-->
      </div>
      <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
  </div>